var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('Base',{style:([_vm.styles])},[_c('div',{attrs:{"data-size":_vm.data.audio.size,"preload":"metadata"}},[_c('div',{staticClass:"wrapper"},[_c('Aud',{style:(_vm.layout),attrs:{"data":_vm.data}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }